const components =  {
    meilisearch: {
        search: { placeholder: "Zoeken op" },
        contacts: {
            search: { 
                buttons: { add: "Een contactpersoon toevoegen" }
            }
        },
    },
    contacts: {
        types: {
            external_collaborator: "Externe medewerker",
            provider: "Leverancier",
            customer: "Klant"
        }
    }
};

export default components;